import CheckDeposit from '../../../../banking/components/check-deposit/CheckDeposit';

export default function CheckDepositPage() {
    return <CheckDeposit />;
}
